// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ebsj","content":"styles_content__1weXv"};